module.exports = __webpack_public_path__ + "static/img/receipt_4_vietlong.b2346162.jpg";